import React from 'react';
import { TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import Summary from './Summary';

const ApplicationSummary = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader
        title={t(
          'specialConsideration->>ApplyForSpecialConsideration.ApplyForSpecialConsideration'
        )}
      />
      <Summary />
    </>
  );
};

export default ApplicationSummary;
